var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-text-field', {
    ref: "input",
    staticClass: "white inline-error",
    staticStyle: {
      "width": "106px"
    },
    attrs: {
      "outlined": "",
      "persistent-hint": "",
      "persistent-placeholder": "",
      "placeholder": "h:mm",
      "hint": _vm.hint,
      "label": _vm.label,
      "rules": [_vm.validate],
      "disabled": _vm.disabled,
      "dense": _vm.dense
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.highlight.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_vm.hour12 ? _c('v-btn', {
          staticClass: "px-2 am-pm",
          class: {
            'not-selected': !_vm.a
          },
          attrs: {
            "absolute": "",
            "text": "",
            "small": _vm.dense,
            "disabled": _vm.disabled
          },
          on: {
            "click": function ($event) {
              _vm.a = _vm.a == 'PM' ? 'AM' : 'PM';
              _vm.$refs.input.validate();
            },
            "keydown": function (e) {
              if ([13, 32, 37, 38, 39, 40, 65, 80].includes(e.keyCode)) {
                e.stopPropagation();
                e.preventDefault();
                if (e.keyCode == 65) _vm.a = 'AM';else if (e.keyCode == 80) _vm.a = 'PM';else _vm.a = _vm.a == 'PM' ? 'AM' : 'PM';
                _vm.$refs.input.validate();
              }
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.a || '--') + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.hmm,
      callback: function ($$v) {
        _vm.hmm = $$v;
      },
      expression: "hmm"
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }